import { makeAutoObservable } from "mobx";
import { ASAPFulfillmentTime, } from "../../ordering";
export class PAsapFulfillmentTime {
    constructor(params) {
        this.type = "ASAP";
        this.purchaseOrderFulfillmentTime = params.purchaseOrderFulfillmentTime;
        // TODO: move ASAP label translations to the client (currently received from RPC)
        this.label = params.purchaseOrderFulfillmentTime.asapLabel;
        makeAutoObservable(this);
    }
    get fulfillmentTime() {
        return this.purchaseOrderFulfillmentTime.fulfillmentTime;
    }
    get isAvailable() {
        return this.purchaseOrderFulfillmentTime.asapOptionAvailable;
    }
    get isActive() {
        return (this.isAvailable &&
            this.fulfillmentTime !== null &&
            this.fulfillmentTime.type === "ASAP");
    }
    setDefaultValue() {
        this.purchaseOrderFulfillmentTime.fulfillmentTime = new ASAPFulfillmentTime(this.label);
    }
    setDate() {
        throw new Error("ASAP fulfillment time cannot set date");
    }
    setHour() {
        throw new Error("ASAP fulfillment time cannot set hour");
    }
}
